import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { open, OpenType } from '@board/open-handler';
import { mapGetters } from 'vuex';
import * as boardTypes from '@board/store/types'
import { IEDate, uGetDateFormat } from '@appbase/util';

import BoardModal from "@board/components/board/BoardModal.vue";
import UserCardComponent from '@appbase/components/common/UserCard/UserCardComponent';

@Component({
    computed: mapGetters({
        popupBaseUrl: boardTypes.POPUP_BASEURL,
    })
})
export default class SummaryList extends UserCardComponent {
    @Prop({ type: Boolean }) preview!: boolean;
    @Prop({ type: Boolean }) includeContent!: boolean;    
    @Prop({ type: Array }) articles!: webpartBoard.WebpartArticle[];

    popupBaseUrl!: string;

    get slicedArticles() {
        return this.articles.slice(0, 4);
    }

    getSlicedTitle(title: string) {
        // 한글 25자, 영문 35자 이상일 때 말줄임 추가
        let maxLength = title.match(/[^\x00-\xff]/g) ? 25 : 35;
        if (title.length > maxLength) {
            return title.substring(0, maxLength) + '\u2026';
        } else {
            return title;
        }
    }
    
    getImagePath(article: webpartBoard.WebpartArticle) {
        // 기본 이미지
        // 00000 : default
        var img = `/cm/gres/faux/images/portal/etc_Thumb.png`;

        // 미리보기시 고정 이미지
        if (this.preview) img = '/cm/gres/faux/images/portal/img-news1.png';
        else if (article) {
            // 본문에 이미지 있는 경우
            if (article.imageFilePath)
                img = `/cm/Portal/Article/api/thumbnail?fileName=${encodeURIComponent(article.imageFilePath)}`;
            else {
                // 본문에 이미지 없는 경우 기본이미지로 설정
                if (article.prefaceId) {
                    let prefaceOpt = (window as any).eumBoardIds.prefaceDefaultImage.filter(
                        (i: any) => i.prefaceId == article.prefaceId && i.boardId == article.boardId,
                    )[0];
                    if (prefaceOpt && prefaceOpt.filename) img = `/cm/gres/faux/images/portal/${prefaceOpt.filename}`;
                }
            }
        }
        return img;
    }

    showNewIcon(article: webpartBoard.WebpartArticle) {
        var oneDay = 1000 * 60 * 60 * 24;
        var createdDate = new Date(article.createdDate.toString());
        var today = new Date();

        var timeSpan = today.getTime() - createdDate.getTime();

        if (timeSpan <= oneDay) {
            return true;
        } else {
            return false;
        }
    }

    getText(val: string | null) {
        if(val == null)
            return '';
        
        var newval = val ? val.replace(/(<([^>]+)>)/gi, '') : '';
        newval = newval.replace(/(&([^;]+);)/g, '');
        return newval;
    }

    convertDate(val: Date) {
        return uGetDateFormat('yyyy-MM-DD', IEDate(val));
    }

    handleClick(artic: webpartBoard.WebpartArticle) {
        if (this.preview) return;

        if (this.isTeams) {
            const modal: appbase.IModalOpenable = this.$refs['modal'] as any;
            const options: appbase.TModalInfo<any> = {
                component: BoardModal,
                props: { boardId: artic.boardId, articleId: artic.articleId, title: artic.title },
                events: {
                    cancel: () => {
                        modal.closeModal();
                    },
                },
            };
            modal.openModal(options);
        } else {
            open(OpenType.PopupRead, {
                boardId: artic.boardId,
                articleId: artic.articleId,
                baseUrl: this.popupBaseUrl,
            });
        }
    }
}